export const toUnixTs = (date: Date) => Math.floor(date.getTime() / 1000);
export const unixTsNow = () => toUnixTs(new Date());
export const getBrowserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
};
